// Our main CSS
import '../css/app.css'
import './claim-report'
import './single-claim-type'

const initNonCritical = async () => {
  // Lazy load video handling
  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]')
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  /*
    Intersecting elements helper
*/
  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

/**
 * 🦄 Alpine.js
 */
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'

declare global {
  interface Window {
    Alpine: typeof Alpine
  }
}

window.Alpine = Alpine

Alpine.store('menu', {
  isOpen: false
})

Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.start()

// MENU TOGGLE

const menuToggleBtn = document.querySelector<HTMLButtonElement>('#menu-toggle-btn')
const mobileMenu = document.querySelector<HTMLDivElement>('#mobile-menu')

menuToggleBtn?.addEventListener('click', () => {
  if (mobileMenu?.classList.contains('open')) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'auto'
  }
})

// TRIGGER PRODUCT MODAL
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search)
  const modalTriggerButtons = document.querySelectorAll('.button-trigger-modal')
  const productModal = document.getElementById('product-modal')
  const productModalContent = document.getElementById('product-modal-content')
  const closeModalBtn = document.getElementById('close-modal')
  const closeModalMobileBtn = document.getElementById('close-modal-mobile')
  const modalBackdrop = document.getElementById('modal-backdrop')
  const isProductPage = document.body.classList.contains('page-template-template-product-page')
  const isViewportDesktop = window.innerWidth > 767

  const timeoutDuration = isViewportDesktop ? 300 : 0 // Set timeout duration based on viewport width

  if (productModal) {
    if (productModal.offsetWidth > 360) {
      productModal.style.width = `${productModal.offsetWidth}px`
    } else if (isViewportDesktop) {
      productModal.style.width = '360px'
    }
  }

  const closeModal = () => {
    if (productModalContent) {
      productModalContent.classList.remove('product-modal-content-open')
      productModalContent.style.paddingTop = '0'
      productModalContent.style.paddingBottom = '0'
    }

    if (modalBackdrop) {
      modalBackdrop.style.display = 'none'
    }

    setTimeout(() => {
      if (productModal) {
        productModal.classList.remove('product-modal-open')

        if (closeModalBtn) {
          closeModalBtn.classList.add('modal-closed')
          closeModalBtn.classList.remove('modal-open')
        }

        if (closeModalMobileBtn) {
          closeModalMobileBtn.classList.add('modal-closed')
          closeModalMobileBtn.classList.remove('modal-open-mobile')
        }
      }
    }, timeoutDuration)
  }

  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', closeModal)
  }

  if (closeModalMobileBtn) {
    closeModalMobileBtn.addEventListener('click', closeModal)
  }

  const openModal = () => {
    if (
      productModal &&
      !productModal.classList.contains('product-modal-open') &&
      productModalContent &&
      modalBackdrop
    ) {
      if (isProductPage && window.scrollY !== 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })

        const onScroll = () => {
          if (window.scrollY === 0) {
            window.removeEventListener('scroll', onScroll)
            executeModalLogic()
          }
        }

        window.addEventListener('scroll', onScroll)
      } else {
        executeModalLogic()
      }
    }
  }

  const executeModalLogic = () => {
    if (productModal && modalBackdrop) {
      productModal.classList.add('product-modal-open')
      modalBackdrop.style.display = 'block'
    }

    setTimeout(() => {
      if (productModal && productModalContent) {
        productModalContent.classList.add('product-modal-content-open')
        productModalContent.style.paddingTop = '48px'
        productModalContent.style.paddingBottom = '40px'

        if (closeModalBtn && isViewportDesktop) {
          closeModalBtn.classList.add('modal-open')
          closeModalBtn.classList.remove('modal-closed')
        }

        if (closeModalMobileBtn && !isViewportDesktop) {
          closeModalMobileBtn.classList.add('modal-open-mobile')
          closeModalMobileBtn.classList.remove('modal-closed')
        }
      }

      // Add the event listener for closing the modal only after the animation is complete
      document.addEventListener('click', closeModalOnOutsideClick)
    }, timeoutDuration)
  }

  const closeModalOnOutsideClick = (event: MouseEvent) => {
    if (
      productModal &&
      productModal.classList.contains('product-modal-open') &&
      !productModal.contains(event.target as Node) && // Check if the click is outside the modal
      !Array.from(modalTriggerButtons).some((button) => button.contains(event.target as Node))
    ) {
      closeModal()
    }
  }

  modalTriggerButtons.forEach((button) => {
    button.addEventListener('click', () => {
      openModal()
    })
  })

  // Check for specific URL parameters and open the modal
  if (urlParams.has('status') || urlParams.has('errorMessage') || urlParams.has('identityToken')) {
    openModal()
  }
})
